module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/2802fceba59929afdf19ed100f513c67.svg";